export default __webpack_public_path__ + "static/media/instagram_kod.d112eb20.webp";